module.exports = __webpack_public_path__ + "static/img/banner4.6a836c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner4.png
// module id = 160
// module chunks = 1